import {
    GET_ADMIN_USER_LIST,
    GET_ADMIN_ASSOCIATED_ACCOUNT,
    GET_USER_ROLE,
    GET_ARDT_LIST,
    GET_ADMIN_ASSOCIATED_PHYSICIAN,
    GET_NEW_ASSIGNMENT,
    UPDATE_USER,
    ADD_ADMIN_PROXIES,
    REVOKE_ADMIN_PROXIES,
    GET_ADMIN_PROXY_LIST,
    IMPERSONATE_ADMIN_PROXY,
    UPDATE_ADMIN_PROXY,
    TERMINATE_ADMIN_PROXY,
    GET_ADMIN_PROXY_USER_LIST,
    GET_DISTRICT,
    GET_TERRITORY,
    GET_ADMIN_USER_LIST_SEARCH,
    GET_FILTER_DETAILS,
} from 'src/pages/admin/redux/action/actionTypes.js';
import {
    getAdminUserList,
    getAssociatedAccountList,
    getUserRole,
    getARDTlist,
    getAssociatedPhysicianList,
    getNewAssignment,
    updateUser,
    getDistrict,
    getTerritory,
    getAdminUserListSearch,
    getfilterDetails,
} from './adminUserListSaga';
import {
    addProxies,
    getProxyList,
    updateProxy,
    getAdminProxyUserList,
} from './adminProxySaga';
import { revokeProxies } from './adminRevokeSaga';
import { adminImpersonateProxy, terminateProxy } from './adminImpersonateSaga';
import { fork, all, takeLatest } from 'redux-saga/effects';

function* watchAdminUserListSaga() {
    yield takeLatest(GET_ADMIN_USER_LIST, getAdminUserList);
}
function* watchAdminUserListSearchSaga() {
    yield takeLatest(GET_ADMIN_USER_LIST_SEARCH, getAdminUserListSearch);
}
function* watchAddProxySaga() {
    yield takeLatest(ADD_ADMIN_PROXIES, addProxies);
}
function* watchGetProxyListSaga() {
    yield takeLatest(GET_ADMIN_PROXY_LIST, getProxyList);
}
function* watchRevokeProxySaga() {
    yield takeLatest(REVOKE_ADMIN_PROXIES, revokeProxies);
}
function* watchAdminImpersonateSaga() {
    yield takeLatest(IMPERSONATE_ADMIN_PROXY, adminImpersonateProxy);
}

function* watchUpdateProxySaga() {
    yield takeLatest(UPDATE_ADMIN_PROXY, updateProxy);
}

function* watchTerminateProxySaga() {
    yield takeLatest(TERMINATE_ADMIN_PROXY, terminateProxy);
}

function* watchAssociatedAccountListSaga() {
    yield takeLatest(GET_ADMIN_ASSOCIATED_ACCOUNT, getAssociatedAccountList);
}
function* watchGetUserRoleSaga() {
    yield takeLatest(GET_USER_ROLE, getUserRole);
}

function* watchGetARDTSaga() {
    yield takeLatest(GET_ARDT_LIST, getARDTlist);
}
function* watchAssociatedPhysicianListSaga() {
    yield takeLatest(
        GET_ADMIN_ASSOCIATED_PHYSICIAN,
        getAssociatedPhysicianList
    );
}
function* watchGetNewAssignmentSaga() {
    yield takeLatest(GET_NEW_ASSIGNMENT, getNewAssignment);
}

function* watchupdateUserSaga() {
    yield takeLatest(UPDATE_USER, updateUser);
}
function* watchAdminProxyUserSaga() {
    yield takeLatest(GET_ADMIN_PROXY_USER_LIST, getAdminProxyUserList);
}
function* watchAdminDistrictSaga() {
    yield takeLatest(GET_DISTRICT, getDistrict);
}
function* watchAdminTerritorySaga() {
    yield takeLatest(GET_TERRITORY, getTerritory);
}
function* watchFilterDetailsSaga() {
    yield takeLatest(GET_FILTER_DETAILS, getfilterDetails);
}
export default function* adminRootSaga() {
    yield all([
        fork(watchAddProxySaga),
        fork(watchRevokeProxySaga),
        fork(watchGetProxyListSaga),
        fork(watchAdminImpersonateSaga),
        fork(watchUpdateProxySaga),
        fork(watchTerminateProxySaga),
        fork(watchAssociatedPhysicianListSaga),
        fork(watchGetARDTSaga),
        fork(watchGetUserRoleSaga),
        fork(watchAssociatedAccountListSaga),
        fork(watchAdminUserListSaga),
        fork(watchGetNewAssignmentSaga),
        fork(watchupdateUserSaga),
        fork(watchAdminProxyUserSaga),
        fork(watchAdminDistrictSaga),
        fork(watchAdminTerritorySaga),
        fork(watchAdminUserListSearchSaga),
        fork(watchFilterDetailsSaga),
    ]);
}
